<template>
  <div id="about">
    <template v-if="$i18n.locale === 'ja'">
      <h1>日本料理のこと</h1>
      <div class="description">
        春は花夏ほととぎす秋は月冬雪さえて冷しかりけり
      </div>
      <div class="dogen">道元禅師</div>
    </template>
    <template v-else>
      <h1>About Japanese cuisine</h1>
      <div class="description en">
        In the spring, cherry blossoms, in the summer the cuckoo.<br/>
        In autumn the moon, and in winter the snow, clear, cold.
      </div>
      <div class="dogen-en">The priest Dōgen</div>
      <div class="dogen-en-translator">translated by Edward G. Seidensticker</div>
    </template>

    <div class="description introduction" v-html="$t('aboutContent')" />
  </div>
</template>

<script>
export default {
};
</script>

<style lang="scss" scoped>

#about {
  margin-bottom: 120px;
  font-size: 11px;
  h1 {
    margin-bottom: 69px;
    letter-spacing: 0.02em;
  }
}

.description {
  line-height: 1.6;
  letter-spacing: 0.06em;
}

.dogen {
  margin-bottom: 27px;
}
.dogen-en-translator {
  margin-bottom: 48px;
}
.owner {
  margin-top: 20px;
}

.dogen-en, .description.en {
  font-size: 12px;
  letter-spacing: -0.005em;
}
.dogen-en-translator {
  letter-spacing: 0;
}

.introduction {
  line-height: 1.9;
}

@media (max-width: ($mobile-vw - 1px)) {
  .introduction {
    width: 340px;
  }
}

@media (max-width: 399px) {
  .dogen, .dogen-en, .dogen-en-translator, .owner {
    text-align: right;
  }
}

@media (min-width: 400px) {
  .dogen {
    margin-left: 247px;
  }
  .dogen-en {
    margin-left: 244px;
  }
  .dogen-en, .description.en {
    font-size: 12px;
    letter-spacing: -0.005em;
  }
  .dogen-en-translator {
    margin-left: 140px;
  }
  .owner {
    margin-left: 250px;
  }
}

@media (min-width: $mobile-vw) {

  #about {
    margin-bottom: 226px;
    margin-top: 40px;
    width: 700px;
  }
  h1 {
    display: none;
  }
  .description, .description.en {
    font-size: 17px;
    line-height: 1.88;
    letter-spacing: 0.07em;
    .narrow {
      letter-spacing: 0.04em;
    }
  }
  .dogen, .dogen-en {
    margin-left: 443px;
  }
  .dogen {
    margin-bottom: 30px;
    font-size: 19px;
    line-height: 1.8;
  }
  .dogen-en {
    font-size: 18px;
    letter-spacing: 0.014em;
  }
  .dogen-en-translator {
    font-size: 15px;
    letter-spacing: 0.014em;
  }
  .dogen-en-translator {
    margin: 12px 0 63px 410px;
  }
  .owner {
    margin-left: 543px;
    margin-top: 40px;
    font-size: 18px;
  }
}
</style>